// UI monolíngue (ver i18n/README.md): o texto vem do bundle pt-BR direto, como
// os `copy.ts` das páginas — este helper roda fora de componente (no `share`).
import companions from '@/i18n/locales/pt-BR/companions.json';

export type CompanionShareTextInput = {
  /** Nome do acompanhante na vaga (`''` = vaga ainda sem nome). */
  companionName: string;
  /** Titular dono do convite (quem está compartilhando). */
  titularName: string | null;
  /** Nome do evento resolvido no bootstrap (null fora do modo evento). */
  eventName: string | null;
};

const interpolate = (template: string, values: Record<string, string>): string =>
  template.replace(/\{\{(\w+)\}\}/g, (_, key: string) => values[key] ?? '');

const firstName = (fullName: string): string => fullName.trim().split(/\s+/)[0] ?? '';

/**
 * Mensagem que acompanha o link pessoal do acompanhante no "Compartilhar":
 * "Oi, {nome}! Você está como acompanhante de {titular} no evento {evento}.
 * Acesse o link para cadastrar sua facial — seu convite é o seu rosto."
 *
 * Cada nome é opcional — vaga criada pelo painel não tem nome, e o titular ou o
 * evento podem faltar na sessão —, então a frase cai para a versão sem aquele
 * pedaço em vez de mostrar "Oi, !" ou "acompanhante de  no evento". O link NÃO
 * entra aqui: vai no campo `url` do share nativo (o app de destino o anexa) e
 * é somado ao texto só na cópia para a área de transferência.
 */
export function buildCompanionShareText({
  companionName,
  titularName,
  eventName,
}: CompanionShareTextInput): string {
  const name = firstName(companionName);
  const titular = (titularName ?? '').trim();
  const event = (eventName ?? '').trim();

  const greeting = name
    ? interpolate(companions.shareGreetingNamed, { name })
    : companions.shareGreeting;

  const role =
    titular && event
      ? interpolate(companions.shareRoleTitularEvent, { titular, event })
      : titular
        ? interpolate(companions.shareRoleTitular, { titular })
        : event
          ? interpolate(companions.shareRoleEvent, { event })
          : companions.shareRole;

  return `${greeting} ${role} ${companions.shareCall}`;
}
